import React, { useEffect, useRef, useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap';

const SelectPromocode = ({
    onChange,
    labelName,
    options,
    defaultValue,
    disabled,
    errorOccured,
    errorMessage
}) => {
    const [activated, setActivated] = useState(false);
    const labelRef = useRef();
    const [coverWidth, setCoverWidth] = useState(0);

    useEffect(() => {
        setCoverWidth(
            labelRef.current ? labelRef.current.getBoundingClientRect().width + 9 : 0
        );
        if (options?.length > 0) {
            setActivated(true);
        }
    }, [labelRef]);

    return (
       

        <>
            <div className="col-12 mb-4">
                <InputGroup
                    className={errorOccured ? "" : "mb-2"}
                    onFocus={() => {
                        setActivated(true);
                    }}
                >
                    {" "}
                    <>
                        <Form.Group controlId="exampleForm.SelectCustom" className="col-12 border-danger">
                            {/* <Form.Label>Select Options</Form.Label> */}
                            <Form.Label
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-activated"
                                    : "textfield-label-unactivated"
                                    } textfield-label`}
                                ref={labelRef}
                                onClick={() => {
                                    setActivated(true);
                                }}>
                                <strong> {labelName}</strong>
                            </Form.Label>
                            <div
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-cover-activated"
                                    : "textfield-label-cover-unactivated"
                                    } textfield-label-cover `}
                                style={{ width: coverWidth }}></div>
                          <Form.Control
    className={`${errorOccured && 'border-danger'}`}
    as="select"
    custom
    required
    onChange={(e) => onChange(JSON.parse(e.target.value))} // Parse the JSON string to get the object back
    value={defaultValue==""?"": JSON.stringify(defaultValue)} // Store the default value as a JSON string
    defaultValue={JSON.stringify(defaultValue)} // Set the default value as a JSON string
    disabled={disabled}>
    <option value={""} disabled>Select Promocode</option>
    {options?.map((option) => (
        <option
            key={option.type_id_ids}
            value={JSON.stringify(option)} // Convert the entire object to a JSON string
        >
            {`${option.type_display_name_chr} `} 
        </option>
    ))}
</Form.Control>

                            <div
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-cover-activated"
                                    : "textfield-label-cover-unactivated"
                                    } textfield-label-cover`}
                                style={{ width: "20px" }}></div>
                        </Form.Group>
                    </>
                    {errorOccured && (
                        <span style={{ color: "red", fontSize: "10px" }}>
                            {errorMessage}
                        </span>
                    )}
                </InputGroup>
            </div>
        </>
    )
}

export default SelectPromocode